import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'asana-webhook-trigger',
  name: 'Asana Webhook Trigger',
  category: 'triggers',
  description: 'Trigger workflows instantly when changes occur in Asana (real-time webhook)',
  icon: 'asana',
  iconType: 'integration-icon',
  color: 'pink',
  version: '1.0.0',

  group: ['trigger'],

  defaults: {
    name: 'Asana Webhook',
    color: '#f06a6a'
  },

  credentials: [
    {
      name: 'asana_oauth2',
      required: true,
      displayName: 'Asana OAuth2'
    }
  ],

  subtitle: '={{ "Webhook on " + ($parameter.resourceGid || "resource") }}',

  inputs: [],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Events'
    }
  ],

  tags: ['asana', 'trigger', 'webhook', 'real-time', 'events'],

  comingSoon: false,

  metadata: {
    documentation: 'https://developers.asana.com/docs/webhooks-guide'
  }
};

export default definition;
